module.exports = function drawSparkle(ctx, color) {
  ctx.save();
  ctx.scale(0.25, 0.25);
  ctx.translate(-27.2, -27.2);
  ctx.fillStyle = color;
  ctx.beginPath();
  ctx.moveTo(54.3, 27.2);
  ctx.bezierCurveTo(30.7, 29.1, 29.1, 30.7, 27.2, 54.3);
  ctx.bezierCurveTo(25.2, 30.7, 23.6, 29.1, 0, 27.2);
  ctx.bezierCurveTo(23.6, 25.2, 25.2, 23.6, 27.2, 0);
  ctx.bezierCurveTo(29.1, 23.6, 30.7, 25.2, 54.3, 27.2);
  ctx.closePath();
  ctx.fill();
  ctx.restore();
};
